import { useMemo, useState, useEffect } from 'react'
// import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import Button from '../../components/reusableElementsComponents/Button'
import WriteAccessGuard from '../../components/reusableElementsComponents/WriteAccessGuard'
import NewPositionGeneral from '../../components/newOpenPositionComponents/NewPositionGeneral'
import NewPositionAssessmentsEdit from '../../components/newOpenPositionComponents/NewPositionAssessmentsEdit'
import TabsMenu from '../../components/reusableElementsComponents/TabsMenu'
import { hasEmptyProperty } from '../../Utilities'
import B2BApiService from "../../B2bApiService";
import { t } from '../../content';


function NewOpenPosition () {
    // const data = useSelector(state => state.contentfulData.all['new open position']);


    const [generalData, setGeneralData] = useState({
        title: "",
        deadline: new Date(),
        description: "",
        industry_id: "",
        target_profile_id: ""
    });

    const [assessmentData, setAssessmentData] = useState({
        assessments: [],
    });

    const [formValidate, setFormValidate] = useState(false);
    const [formCompleted, setFormCompleted] = useState(false);
    const [validateTextFields, setValidateTextFields] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
        // eslint-disable-next-line
    }, [formCompleted]);

    const backToPositions = () => {
        navigate("/open-positions");
    }
    const activeKey = (key) => { }

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }
        , []);

    let template = {
        tabs: [
            {
                component: <NewPositionGeneral data={generalData} updateData={setGeneralData} formValidate={formValidate} validateTextFields={validateTextFields} />,
                sectionTitle: 'general'
            },
            {
                component: <NewPositionAssessmentsEdit data={assessmentData.assessments} updateData={data => setAssessmentData({assessments: data})} setPoolDataEditedFlag={() => false} />,
                sectionTitle: 'assessments'
            }
        ]
    }

    function handleBeforeUnload (event) {
        if (!formCompleted) {
            event.preventDefault();
            event.returnValue = ""

        }
    }

    return (
            <div className="new-open-position">
                
                <div className="exit">
                    <span className="icon icon-exit" onClick={backToPositions}>&nbsp;</span>
                </div>
                <p className='bold m section title'>{t('emptyStates.openPositions.cta')}</p>
                <TabsMenu template={template} center activeKey={activeKey} />
                <br />
                <br />
                <WriteAccessGuard>
                    <Button btnstyle={'mazhrBtn default-green tall'} type='button' onClick={onSubmit}>
                        {t('emptyStates.openPositions.cta')}
                    </Button>
                </WriteAccessGuard>
            </div>
        )

    function onSubmit () {

        setValidateTextFields(true);
        let empty = hasEmptyProperty(generalData, ['title', 'deadline', 'industry_id', 'target_profile_id'])
        if (empty !== false) {
            /**
             * @todo : Show error thing here
             */
            setFormValidate(true);
            return;
        }


        let tempGeneralData = generalData;

        tempGeneralData.deadline = new Date(tempGeneralData.deadline)

        let deadlineDateString = tempGeneralData.deadline.getFullYear() + "/";

        deadlineDateString += ("0" + (tempGeneralData.deadline.getMonth() + 1)).slice(-2) + "/";
        deadlineDateString += ("0" + tempGeneralData.deadline.getDate()).slice(-2);

        deadlineDateString += " " + ("0" + tempGeneralData.deadline.getHours()).slice(-2) + ":"
        deadlineDateString += ("0" + tempGeneralData.deadline.getMinutes()).slice(-2) + ":";

        deadlineDateString += ("0" + tempGeneralData.deadline.getSeconds()).slice(-2);

        tempGeneralData.deadline = deadlineDateString;

        let tempAssessmentData = assessmentData

        setFormCompleted(true);

        b2bServiceObj.SavePool(JSON.stringify({ ...tempGeneralData, ...tempAssessmentData }), (response) => {
            if (response) {
                navigate("/open-positions/" + response?.json?.data[0]?.hash);
            }
        })
    }
}

export default NewOpenPosition

